<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <h1 v-translate>Štítky</h1>
    </div>
    <div class="inner_white">
        <div class="status search">
          <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a
              v-if="$_createActionAllowed"
              :title="'Přidat štítek' | translate"
              :class="['add', 'add_expand', { open: newTagOpen }, { btn_inactive: false}]"
              @click.prevent="toggleNewTag()"
              v-translate>Přidat štítek
          </a>
        </div>
      <div :class="['filter', 'expand_content', { open: newTagOpen }]">
        <div class="field_left">
          <p>
          <text-input
              id="tag-name-add-1"
              v-model="newTag.name"
              :required="true"
              ref="newtagnameref"
          >
            <translate class="translate">Název štítku</translate>
          </text-input>
          </p>
          <p v-if="canChangeOperator">
            <operator-select
                v-model="newTag.id_operator"
                :options="operatorOptions"
            >
            </operator-select>
          </p>
        </div>
        <div class="field_right field_btn">
          <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addNewTag"
          />
        </p>
        </div>
      </div>
      <form>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="tags-list">
      <table class="vypis" ref="table_with_action_line">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in tagsTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit"></th>
        </tr>
        </thead>

        <tag-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            :selectedEntities="selectedEntities"
            @input="select"
            @updateTag="updateEntity"
            @deleteTag="deleteEntity"
            :ref="'tag-row-ref-'+entity.id"
        ></tag-row>
        <tr v-if="entities.length === 0">
             <td colspan="8">{{ $gettext('Nebyly nalezeny žádné štítky.') }}</td>
        </tr>
      </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="tags-list"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
      </form>
    </div>
  </div>
</template>

<script>
import TagRow from "@/components/views/tags/TagRow"
import listActions from "@/components/mixins/list-actions"
import selectOperator from "@/components/mixins/select-operator-business-model"
import OperatorSelect from "../../common/OperatorSelect.vue";

export default {
  name: "Tags",
  components: {
    TagRow,
    OperatorSelect
  },
  mixins: [listActions, selectOperator],
  data() {
    return {
      operators: [],
      moduleName: 'tags',
      newTagOpen: false,
      newTag: {
        name: '',
        id_operator: null,
      },
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(TagService, OperatorService) {
    this.entityService = TagService
    this.operatorService = OperatorService
    this.createdInit();
    if(this.canChangeOperator) {
      this.operatorService.getOperators().then((data) => {
        this.id_operator = this.$_loggedUser_selectedOperatorId;
        this.operators = data['operators'];
        this.operators = [{'id': null, 'name': this.$gettext('Nenastaven')}, ...this.operators];
      })
    }
  },
  computed: {
    canChangeOperator(){
      return this.$_loggedUser_canChangeOperator;
    },
    tagsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název štítku'), column: 'sName'},
        {key: 2, name: this.$gettext('Operátor'), column: 'sOperator'},
        {key: 3, name: this.$gettext('Počet plátců'), column: 'sBillersCount'},
        {key: 4, name: this.$gettext('Počet odběratelů'), column: 'sSubscribersCount'},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.tagsTableTitles)
      headers.operator.callback = entity => {return entity.operator_name;};

      return headers;
    },
  },
  methods: {
    toggleNewTag() {
      this.newTagOpen = !this.newTagOpen
      this.$emit('new-tag-open', this.newTagOpen)
      if (this.newTagOpen) {
        this.resetInput('newtagnameref')
      }
    },
    addNewTag() {
      this.entityService.createEntity(this.newTag)
          .then(() => {
            this.getEntities()
            this.setSuccessMessage()
            this.$refs['newtagnameref'].setForcedInvalid(false)
            this.newTagOpen = false;
          })
          .catch((error) => {
            this.setErrorMessage(this._processListErrorMessage(error))
          })
    },
    resetInput(ref) {
      this.$refs[ref].setForcedInvalid(false)
      this.$refs[ref].setTouched(false)
      this.newTag.name = ''
    },
    _processListErrorMessage(error) {
      let errorMessage = error['error_message']
      if (errorMessage === "Can't delete tag when is assigned to subscriber or biller.") {
        errorMessage = this.$gettext('Nelze smazat tag, pokud je přiřazený k nějakému plátci nebo odběrateli.')
      } else {
        this._.forEach(error['validation_errors'], function (message) {
          if (this._.includes(message, 'is not unique')) {
            errorMessage = this.$gettext('Jméno štítku není unikátní.');
            this.$refs['newtagnameref'].setForcedInvalid(true, this.$gettext('Jméno musí být unikátní'));
          } else if (this._.includes(message, 'name must be set')) {
            errorMessage = this.$gettext('Jméno štítku musí být uvedeno.');
            this.$refs['newtagnameref'].setForcedInvalid(true, this.$gettext('Zadejte název'));
          } else if (this._.includes(message, 'Unable to delete Tag')) {
            errorMessage = this.$gettext('Nelze smazat tag, pokud je přiřazený k nějakému plátci nebo odběrateli.');
          }
        }.bind(this))
      }
      return errorMessage
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/tags/TagsList.vue